const FilesOptions = {
  VALID_FILE_EXTENSIONS: '.jpg, .jpeg, .png, .pdf, .xlsx, .xls, .ods',
  EXCEL_FILE_TYPES: ['xlsx', 'ods', 'xls'],
  FILE_MIME_MATCHING: {
    jpg: {
      fileExtension: 'jpg',
      mimeType: 'image/jpeg',
    },
    jpeg: {
      fileExtension: 'jpeg',
      mimeType: 'image/jpeg',
    },
    png: {
      fileExtension: 'png',
      mimeType: 'image/png',
    },
    pdf: {
      fileExtension: 'pdf',
      mimeType: 'application/pdf',
    },
    xlsx: {
      fileExtension: 'xlsx',
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    xls: {
      fileExtension: 'xls',
      mimeType: 'application/vnd.ms-excel',
    },
    ods: {
      fileExtension: 'ods',
      mimeType: 'application/vnd.oasis.opendocument.spreadsheet',
    },
  },
  CONVERSION_FACTOR: 1024,
  TIME_BEFORE_FILE_IS_DELETED: 1000,
};

export default FilesOptions;
